import { render, staticRenderFns } from "./ButtonDelete.vue?vue&type=template&id=0b82f270&scoped=true&lang=html"
import script from "./ButtonDelete.vue?vue&type=script&lang=js"
export * from "./ButtonDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../gestion-tache-vuejs-v2/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b82f270",
  null
  
)

export default component.exports